var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-iar-red-envelope"},[_c('div',{staticClass:"plv-iar-red-envelope__popup"},[_vm._t("default"),_vm._v(" "),_c('mobile-red-envelope-close',{on:{"close":function($event){return _vm.$emit('close')}}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }